import {
  fetchPaymentOptions,
  fetchMyOptions,
  postMyOption,
  updateMyOption,
  deleteOption,
} from "@/api";
import type { PaymentOptionBase, PaymentOptionMy } from "@/shared/types";

interface GroupeBaseOption extends PaymentOptionBase {
  children: PaymentOptionBase[];
}

export const usePaymentOptionsStore = defineStore("paymentOptions", () => {
  const allBaseOptions = ref<PaymentOptionBase[]>([]);
  const myOptions = ref<PaymentOptionMy[]>([]);
  const optionsLoading = ref(false);
  const myOptionsLoading = ref(false);

  const baseOptionsGrouped = computed(() => {
    const grouped: GroupeBaseOption[] = [];
    const parents = allBaseOptions.value.filter(
      (option) => option.parent_id === 0
    );
    parents.forEach((parent) => {
      const children = allBaseOptions.value.filter(
        (option) => option.parent_id === parent.bpo_id
      );
      grouped.push({ ...parent, children });
    });
    return grouped;
  });

  const getBaseOptions = async () => {
    if (optionsLoading.value) return;
    optionsLoading.value = true;
    const res = await fetchPaymentOptions();
    allBaseOptions.value = res;
    optionsLoading.value = false;
  };
  const getMyOptions = async () => {
    if (myOptionsLoading.value) return;
    myOptionsLoading.value = true;
    const res = await fetchMyOptions();
    myOptions.value = res;
    myOptionsLoading.value = false;
  };
  const addMyOption = async (baseId: number, text: string) => {
    const res = await postMyOption(baseId, text);
    await getMyOptions();
    return res;
  };

  const getOptionById = (id: number) => {
    return allBaseOptions.value.find((option) => option.bpo_id === id);
  };
  const getMyOptionById = (id: number) => {
    return myOptions.value.find((option) => option.upo_id === id);
  };

  const editMyOption = async (id: number, text: string) => {
    await updateMyOption(id, text);
    await getMyOptions();
  };

  const deleteMyOption = async (id: number) => {
    await deleteOption(id);
    await getMyOptions();
  };

  return {
    allBaseOptions,
    baseOptionsGrouped,
    myOptions,
    getBaseOptions,
    getMyOptions,
    addMyOption,
    getOptionById,
    getMyOptionById,
    editMyOption,
    deleteMyOption,
  };
});
